module.exports = __webpack_public_path__ + "img/fake_img.e05d40f7.png";